<template>
  <div ref="root" class="mx-auto w-full max-w-3xl">
    <div data-reveal class="flex flex-col items-center gap-4 text-center sm:flex-row sm:text-left">
      <UserTile :size="96" />
      <div>
        <h2 class="text-2xl font-bold text-[var(--text)]">{{ loc(profile.name) }}</h2>
        <p class="font-mono text-xs text-[var(--muted)]">{{ t('hero.aka') }}</p>
        <p class="mt-1 font-mono text-sm text-[var(--accent)]">{{ loc(profile.role) }}</p>
      </div>
    </div>
    <p data-reveal class="mt-4 text-sm leading-relaxed text-[var(--muted)]">
      {{ loc(profile.summary) }}
    </p>
    <dl data-reveal-group class="mt-4 space-y-2">
      <div
        v-for="fact in profile.facts"
        :key="loc(fact.label)"
        data-reveal-item
        class="flex flex-col gap-0.5 rounded border border-[var(--border)] bg-[var(--surface)] px-3 py-2 sm:flex-row sm:gap-3"
      >
        <dt class="shrink-0 font-mono text-xs uppercase text-[var(--accent)] sm:w-28">
          {{ loc(fact.label) }}
        </dt>
        <dd class="text-sm text-[var(--text)]">{{ loc(fact.value) }}</dd>
      </div>
    </dl>
    <div data-reveal class="mt-4 flex flex-wrap justify-center gap-3 sm:justify-start">
      <a
        href="https://github.com/lnxdxtf"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex items-center gap-2 rounded-md bg-[var(--accent)] px-4 py-2 font-mono text-sm text-[var(--bg)] transition-opacity hover:opacity-90"
      >
        <Icon icon="mdi:github" /> {{ t('hero.github') }}
      </a>
      <a
        href="https://www.linkedin.com/in/gabrielrmichaliszen"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex items-center gap-2 rounded-md border border-[var(--border)] px-4 py-2 font-mono text-sm transition-colors hover:border-[var(--accent)] hover:text-[var(--accent)]"
      >
        <Icon icon="mdi:linkedin" /> {{ t('hero.linkedin') }}
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { Icon } from '@iconify/vue'
import UserTile from '../xp/UserTile.vue'
import { loc, profile } from '../data'
import { useReveal } from '../composables/useMotion'

const { t } = useI18n()
const root = ref<HTMLElement | null>(null)
useReveal(root)
</script>
